//libraries
import React from 'react'

// components
import Balloon from '/react4xp/components/Balloon'
import Mask from '/react4xp/components/Mask'
import Image from '/react4xp/components/Image'
import Button from '/react4xp/components/Button'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// props types
interface HeroBannerPropsMedium {
    title?: string
    subtitle?: string
    src?: string
    srcMedium?: string
    alt?: string
    text?: string
    buttonText?: string
    href?: string
    hrefExternal?: boolean
}

export default function HeroBannerMedium({
    title,
    subtitle,
    src,
    srcMedium,
    alt,
    text,
    buttonText,
    href,
    hrefExternal
}: HeroBannerPropsMedium) {
    return (
        <div className='hero-banner hero-banner-medium'>
            <div className='wrapper'>
        
                <div className='flex-top'>

                    {isNonWhitespaceString(title) && (
                        <div className='white-balloon'>
                            <Balloon
                                arrow='bottom-left'
                                arrowSize='medium'
                                arrowSide='right'
                                balloonSide='left'
                                balloonColor='white'
                                spacing='big'
                            >
                                <h1 className='h1-hero line-break'>
                                    {title}
                                </h1>
                            </Balloon>
                        </div>
                    )}
                    
                    {isNonWhitespaceString(subtitle) && (
                        <div className='blue-balloon-mobile'>
                            <Balloon
                                arrow='bottom-right'
                                arrowSize='small'
                                arrowSide='left'
                                balloonSide='right'
                                balloonColor='blue-dark'
                                spacing='medium'
                            >
                                <h2 className='h1-hero-small line-break'>
                                    {subtitle}
                                </h2>
                            </Balloon>
                        </div>
                    )}

                    {isNonWhitespaceString(src) && (
                        <Mask className='image'>
                            <Image
                                src={src}
                                srcMedium={srcMedium}
                                width={900}
                                alt={alt}
                                sizes='
                                    (max-width: 768px) 100vw,
                                    50vw
                                '
                                className='cover'
                            />
                        </Mask>
                    )}

                </div>

                <div className='flex-bottom'>

                    {(isNonWhitespaceString(text) || isNonWhitespaceString(buttonText)) && (
                        <Mask className='content' bgColor='white' spacing='small'>

                            {isNonWhitespaceString(text) && (
                                <div
                                    className='text-medium'
                                    dangerouslySetInnerHTML={{ __html: text }}
                                    suppressHydrationWarning
                                />
                            )}

                            {isNonWhitespaceString(buttonText) && (
                                <Button
                                    href={href}
                                    hasBorders
                                    hover='blue-dark'
                                    noUnderline
                                    target={!!hrefExternal}
                                >
                                    {buttonText}
                                </Button>
                            )}

                        </Mask>
                    )} 

                    {isNonWhitespaceString(subtitle) && (
                        <div className='blue-balloon'>
                            <Balloon
                                arrow='bottom-middle'
                                arrowSize='medium'
                                arrowSide='left'
                                balloonSide='right'
                                balloonColor='blue-dark'
                                spacing='medium'
                            >
                                <h2 className='h1-hero-small line-break'>
                                    {subtitle}
                                </h2>
                            </Balloon>
                        </div>
                    )}

                </div>

            </div>
        </div>
    )
}